/** Upload placeholders — never show these as a "detected visual style". */
const STYLE_PLACEHOLDER_RE = /^(Image reference saved|Image reference\b|Upload saved)\b/i;

/**
 * Human-readable visual style from an attachment analysis blob.
 * Prefers structured style_profile (same as dashboard hero), never the
 * generic "Image reference saved (…)" analysis_summary fallback.
 */
export function styleNoteFromAnalysis(analysis) {
  if (!analysis || typeof analysis !== 'object') return '';
  const profile = analysis.style_profile;
  if (profile && typeof profile === 'object') {
    const summary = String(profile.summary || '').trim();
    if (summary && !STYLE_PLACEHOLDER_RE.test(summary)) return summary;
    const art = profile.art_direction || {};
    const tokens = [art.primary_style, art.artistic_medium, art.aesthetic]
      .map((v) => String(v || '').trim())
      .filter(Boolean);
    if (tokens.length) return tokens.join(', ');
  }
  const prose = String(analysis.image_style_description || '').trim();
  if (prose && !STYLE_PLACEHOLDER_RE.test(prose)) return prose;
  const ref = analysis.image_reference || {};
  const refDesc = String(ref.visual_style_description || '').trim();
  if (refDesc && refDesc !== 'unknown' && !STYLE_PLACEHOLDER_RE.test(refDesc)) return refDesc;
  return '';
}

/** True when a note is the generic upload placeholder, not real style prose. */
export function isStylePlaceholderNote(text) {
  return STYLE_PLACEHOLDER_RE.test(String(text || '').trim());
}
